import * as _ from 'lodash';
import { AbstractControl, FormGroup } from '@angular/forms';
import { computed, effect, Injectable, Signal, signal, untracked, WritableSignal } from '@angular/core';

import { LogService } from '../log.service';
import { _ModelService } from './_model.service';

export type EntityKeyName = 'id' | 'guid';

@Injectable()
export abstract class _FormModelService
    extends _ModelService
{
    abstract controlId_focus: string | null;
    abstract form: FormGroup;
    abstract keyName_entity: EntityKeyName;

    abstract form$$: WritableSignal<FormGroup | null>;
    abstract controls$$: Signal<{[key: string]: AbstractControl<any, any, any>;} | undefined>;

    protected _computed_controls$$ = computed(() => this.form$$()?.controls);
    protected _form$$ = signal<FormGroup | null>(null);

    protected _controlId_focus: string | null = null;

    constructor() {
        super();
        // Alleen dataModel$$ is de afhankelijkheid. reset/patchValue untracked: controls schrijven via hun
        // ControlValueAccessor synchroon naar eigen signals (bv. MatButtonToggleGroup.writeValue leest en zet
        // _tabIndex van elke toggle); binnen het effect getrackt zou het effect zichzelf eindeloos opnieuw starten
        // (browser liep vast bij opslaan van DomainUserEdit, 2026-11-01). Ook valueChanges-handlers lopen hier mee.
        effect(() => {
            const __dataModel = this.dataModel$$();
            untracked(() => {
                this.form.reset();  // Set all values to null. Because form is global const;
                this.form.patchValue(__dataModel);
                this.form$$.set(this.form);
            });
        })
    }

    dtoModel_loadFromForm(): unknown {
        const __dataModel = this.dataModel$$();
        const __newDataModel = {...__dataModel, ...this.form.value};
        this.dataModel$$.set(__newDataModel);
        const _newDtoData = this.dtoModel_alter(__newDataModel);

        this.dtoModel_merge(_newDtoData);
        // this.form_reset();

        return this.dtoModel$$();
    }

    form_reset(): void {
        this.form.reset(this.dataModel$$());
    }

    form_resetFromDirty(): void {
        if (this.form?.dirty || this.form.value !== this.dataModel$$()) {
            setTimeout(() => {
                LogService.envDev.logString('edit form','form reset');
                this.form_reset();
            }, 0);
        }
    }

    // formModel_fromForm(): any {
    //     if (!this.form || this.form.invalid) { return; }

    //     const formModel = this.dataModel$$();
    //     return _.assign(formModel, this.form.value);
    // }
}

